// extracted by mini-css-extract-plugin
export default {"errorWrapper":"App_errorWrapper__aAH0x","innerWrapper":"App_innerWrapper__Hr230"};